import { lightTheme } from "@/customTheme";
import { styled } from "baseui";
import Icons from "../Icons";
import Tooltip from "@/components/Tooltip";

interface IAddScene {
  onAdd: () => void
  setHoveringId: (hoveringId: 'add-scene' | null) => void
}
const ItemContainer = styled('div', (props: any) =>({
    userSelect: 'none',
    width: '64px',
    height: '64px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: lightTheme.colors.grayScale150,
    borderRadius: '8px',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.3s ease-out',
    ':hover': {
        background: lightTheme.colors.grayScale200,
    },
    ':active': {
      background: lightTheme.colors.grayScale250
    },
    ...props.$style
}));

const AddScene: React.FC<IAddScene> = ({
    onAdd,
    setHoveringId,
}) => {

    return (
      <ItemContainer 
        onClick={onAdd}
        onMouseEnter={() => setHoveringId('add-scene')}
        onMouseLeave={() => setHoveringId(null)}
      >
        <Tooltip info={{content: 'Add page', placement: 'top'}} ignoreBoundary={true}>
          <div style={{ width: '100%', height: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <Icons.PlusIcon size={24}/>
          </div>
        </Tooltip>
      </ItemContainer>
    )
}

export default AddScene;